/**
 * Labstep
 *
 * @module grid/SmartTableProtocolCondition/components/ToolPanel/AddColumn/Resource
 * @desc Lists for Resource
 */

import { EntityTemplateSectionItem } from 'labstep-web/components/Entity/Template/SectionItem';
import { MetadataActionCreateModalDropdown } from 'labstep-web/components/Metadata/Action/Create/Modal/Dropdown';
import { ICONS } from 'labstep-web/constants/icons';
import { SectionHeader } from 'labstep-web/core/Header';
import { EntityDataGridToolPanelListItem } from 'labstep-web/grid/SmartTableProtocolCondition/components/ToolPanel/ListItem';
import type { IndexTemplatableEntity } from 'labstep-web/models';
import type { EntityView } from 'labstep-web/models/entity-view.model';
import { Metadata } from 'labstep-web/models/metadata';
import {
  type MetadataParent,
  MetadataType,
} from 'labstep-web/models/metadata/types';
import { Resource } from 'labstep-web/models/resource.model';

export const getResourceLists = (
  entityView: EntityView,
  selectMetadata: (
    metadata: Metadata,
    parentEntityClass: string,
  ) => void,
  colIds: string[],
  template?: IndexTemplatableEntity,
) => [
  {
    key: Metadata.entityName,
    entityName: Metadata.entityName,
    searchField: 'label_like',
    params: template
      ? {
          metadata_thread_id: template.metadata_thread.id,
          count: 8,
        }
      : {
          permission_class: Resource.entityName,
          group_id: entityView.group.id,
          group_by_label: 1,
          sort: 'label',
          count: 8,
        },
    header: (
      <SectionHeader label="Resource Metadata Fields">
        {template && (
          <EntityTemplateSectionItem template={template} />
        )}
      </SectionHeader>
    ),
    listItem: (entity: object) => {
      const metadata = entity as Metadata;

      return (
        <EntityDataGridToolPanelListItem
          icon={
            ICONS.metadata.type[
              metadata.type as keyof typeof ICONS.metadata.type
            ] || 'database'
          }
          actionIcon={
            metadata.type === MetadataType.molecule
              ? 'arrow right'
              : 'eye'
          }
          text={metadata.label || 'Untitled data field'}
          onClick={() =>
            selectMetadata(metadata, Resource.entityName)
          }
          disabled={colIds.includes(metadata.colId)}
        />
      );
    },
    bottomAction: template ? (
      <MetadataActionCreateModalDropdown
        isTemplate={true}
        entity={template as MetadataParent}
      />
    ) : undefined,
  },
];
